export const state = () => ({
  cards: [],
  selectedCards: [],
  currentStepCards: [],
  currentStepSelectedCards: [],
  discountTitle: '',
  priceDiscount: 0,
})

export const mutations = {
  setCards(state, payload) {
    state.cards = payload
  },
  setSelectedCards(state, payload) {
    state.selectedCards = payload
  },
  addSelectedCard(state, payload) {
    state.selectedCards.push(payload)
  },
  unshiftSelectedCard(state, payload) {
    state.selectedCards.unshift(payload)
  },
  deleteSelectedCard(state, payload) {
    state.selectedCards.splice(payload.index, payload.amount)
  },
  setCurrentStepCards(state, payload) {
    state.currentStepCards = state.cards.filter((el) => el?.StepLink === payload).sort((a, b) => a.Order.toString().localeCompare(b.Order.toString()))
  },
  setCurrentStepSelectedCards(state, payload) {
    state.currentStepSelectedCards = state.cards.filter((el) => el.StepLink === payload && state.selectedCards.some((e) => e.Id === el.Id))
  },
  setDiscountTitle(state, payload) {
    state.discountTitle = payload
  },
  setPriceDiscount(state, payload) {
    state.priceDiscount = payload
  },
  resetSelectedCards(state) {
    state.selectedCards = []
    state.discountTitle = ''
    state.priceDiscount = 0
    state.currentStepSelectedCards = []
  },
}

export const actions = {
  async getCards({ commit }) {
    const stepCardsJson = require(`~/StepsJSon/${this.$config.CustomProductData.CurrentProductVar}/card-buy-page.json`)
    // console.log('cards.js getCards called .....')
    await commit('setCards', stepCardsJson.cards)
  },
}
